import React from 'react';
import BaseModal from 'src/components/Modal/BaseModal';
import { Box, SvgIcon, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AlertTriangle } from 'react-feather';
import Button from './Button';
import useModal from './Modal/useModal';

const useStyles = makeStyles(() => ({
  root: {
    minHeight: 200,
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: 75,
    height: 75,
  }
}));

function ConfirmationModal({
  title,
  text,
  callback,
  render,
  icon: Icon,
  buttonLook = 'error'
}: any) {
  const { isOpen, openModal, closeModal } = useModal();
  const [isLoading, setIsLoading] = React.useState(false);
  // eslint-disable-next-line consistent-return
  const confirm = () => {
    setIsLoading(true);
    const result = callback();

    if (result) { // todo - check if promise
      result.then(() => {
        closeModal();
        setIsLoading(false);
      });
    } else {
      closeModal();
      setIsLoading(false);
    }
  };
  const classes = useStyles();

  return isOpen ? (
    <>
      <BaseModal
        onClose={closeModal}
        title={title}
      >
        <Box className={classes.root}>
          <SvgIcon className={classes.icon}>
            <Icon />
          </SvgIcon>
          <Box mt={1}>
            <Typography
              variant="subtitle1"
              color="textSecondary"
            >
              {text}
            </Typography>
          </Box>
        </Box>
        <Button onClick={confirm} look={buttonLook} fullWidth isLoading={isLoading}>
          {title}
        </Button>
      </BaseModal>
      { render({ onClick: openModal }) }
    </>
  ) : render({ onClick: openModal });
}

ConfirmationModal.defaultProps = {
  title: 'Are you sure you want to proceed?',
  icon: AlertTriangle,
};

export default ConfirmationModal;
